/* bf-chrome.js — BF mobile redesign (2026-09). Stream file; gate every behaviour on BF.isMobile(). Loaded deferred after bf-core.js. */
(function () {
  "use strict";
  if (!window.BF) return;

  var BF = window.BF;
  var doc = document;

  /* ===================================================================
     A2 · menu sheet — lift it out of the header's stacking context
     The sheet is authored in sections/header.liquid because its tiles,
     accessories and links are blocks of that section. That puts it inside
     `.section-header`, which base.css:2511-2520 pins position:fixed and A1
     re-tiers to z-index var(--bf-z-header) (50) — a stacking context. A
     descendant of it therefore paints BELOW the shared backdrop
     (#bf-backdrop, z 55), a body-level sibling, whatever its own z-index,
     and inherits the wrapper's pointer-events:none. Moving the node to
     <body> on load restores the contract's paint order
     (header 50 < backdrop 55 < sheet 60), which is the prototype's own
     (.dc.html: header z 5 < backdrop z 10 < menu z 11).
     Idempotent; re-runs when the theme editor re-renders the header.
     =================================================================== */
  function portalMenuSheet() {
    var all = doc.querySelectorAll('[data-bf-sheet="menu"]');
    if (!all.length) return;
    var sheet = all[0];                       /* the in-section copy is first in DOM order */
    for (var i = 1; i < all.length; i++) {    /* drop a stale copy left by a section re-render */
      if (all[i].parentNode) all[i].parentNode.removeChild(all[i]);
    }
    if (sheet.parentNode !== doc.body) doc.body.appendChild(sheet);
  }

  BF.ready(portalMenuSheet);
  doc.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bf-sheet="menu"]')) portalMenuSheet();
  });

  /* ===================================================================
     A1 · mobile header card
     - hide on scroll-down / reveal on scroll-up (PROTOTYPE-MAP §3, D4 §1.4)
     - dark glass over a hero, light glass otherwise (CONTRACTS §14)
     - cart badge from bf:cart:updated (CONTRACTS §5)
     The sheet openers (data-bf-open) are handled declaratively by bf-core.js.
     =================================================================== */
  BF.ready(function () {
    var card = doc.querySelector('[data-bf-header]');
    if (!card) return;

    var badge = card.querySelector('[data-bf-cart-count]');
    /* the header never hides on a product page (D4 §1.4) */
    var isPdp =
      card.getAttribute('data-bf-page') === 'product' ||
      doc.body.classList.contains('template-product');

    var HIDE_DY = 6;      /* downward delta that hides */
    var HIDE_AT = 90;     /* absolute scroll past which hiding is allowed */
    var TOP_AT = 8;       /* forced reveal at/under this scroll position */

    var lastY = window.scrollY || window.pageYOffset || 0;
    var hidden = false;
    var dark = null;      /* null = never painted yet */
    var ticking = false;

    /* Threshold above which the glass turns light. -1 = no hero on this page.
       Re-queried per evaluation: heroes are server-rendered but a section can be
       re-rendered (bf:section:rendered) and the cost is one querySelector/frame. */
    function glassThreshold() {
      var hero = doc.querySelector('.bf-hero, [data-bf-hero]');
      if (!hero) return -1;
      var attr = parseInt(hero.getAttribute('data-bf-glass-until'), 10);
      if (!isNaN(attr)) return attr;
      return Math.min(500, Math.round(0.66 * window.innerHeight));
    }

    function evaluate() {
      var y = window.scrollY || window.pageYOffset || 0;

      /* glass state */
      var threshold = glassThreshold();
      var wantDark = threshold >= 0 && y < threshold;
      if (wantDark !== dark) {
        card.classList.toggle('is-dark', wantDark);
        dark = wantDark;
      }

      /* hide / reveal */
      if (!isPdp) {
        var dy = y - lastY;
        if (dy > HIDE_DY && y > HIDE_AT && !hidden) hidden = true;
        else if (dy < -HIDE_DY && hidden) hidden = false;
        if (y <= TOP_AT && hidden) hidden = false;
        card.classList.toggle('is-hidden', hidden);
      }

      lastY = y;
    }

    function schedule() {
      if (!BF.isMobile() || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        evaluate();
      });
    }

    function reset() {
      hidden = false;
      dark = null;
      lastY = window.scrollY || window.pageYOffset || 0;
      card.classList.remove('is-hidden', 'is-dark');
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    BF.on('bf:section:rendered', schedule);
    BF.onMobileChange(function () {
      if (BF.isMobile()) { reset(); paintBadge(); evaluate(); } else { reset(); }
    });

    /* ---- cart badge (CONTRACTS §5; core emits once on load from the server-rendered count) ---- */
    var count = badge ? parseInt(badge.getAttribute('data-bf-cart-count'), 10) || 0 : 0;

    function paintBadge() {
      if (!badge) return;
      var n = count;
      var was = badge.textContent;
      badge.setAttribute('data-bf-cart-count', String(n));
      badge.textContent = String(n);
      badge.hidden = n === 0;
      if (n > 0 && was !== String(n)) {
        /* replay bfIn (CONTRACTS §10) */
        badge.style.animation = 'none';
        void badge.offsetHeight;
        badge.style.animation = '';
      }
      /* keep the legacy mobile twin honest — it is display:none at ≤ 749 px, so this is bookkeeping only */
      var twin = doc.getElementById('cart-icon-bubble-mobile');
      var num = twin && twin.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (num) num.textContent = n < 100 ? String(n) : '';
    }

    BF.on('bf:cart:updated', function (e) {
      var n = e.detail && e.detail.item_count;
      if (typeof n !== 'number' || isNaN(n)) return;
      count = n;
      if (BF.isMobile()) paintBadge();
    });

    /* ---- sheet state hook (A2 styles it; the shared backdrop already covers the card) ---- */
    BF.on('bf:sheet:open', function () { card.classList.add('is-under-sheet'); });
    BF.on('bf:sheet:close', function () {
      if (!BF.currentSheet()) card.classList.remove('is-under-sheet');
    });

    if (BF.isMobile()) evaluate();
  });

  /* ===================================================================
     A3 · search sheet (prototype §2.8, D4 §9)
     Opening / closing / Escape / focus trap / [data-bf-autofocus] and the
     "no backdrop for search" rule all live in bf-core.js. This block owns
     only the three body states:
       empty   -> Recent (localStorage `bf:recent`) + Popular chips
       results -> <=5 product rows + collection rows + View all results
       none    -> `No results for "q"` + the five line tiles
     /search/suggest.json is DEBOUNCED 150 ms and the in-flight request is
     aborted on every keystroke (CONTRACTS §14 ruling, 03:05) — the prototype
     filters synchronously with no debounce, but the Cloudflare bot cap
     forbids a burst per keystroke. At most one request is ever in flight.
     =================================================================== */
  BF.ready(function () {
    var root = doc.querySelector('[data-bf-search-root]');
    if (!root) return;

    var input = root.querySelector('[data-bf-search-input]');
    var body = root.querySelector('.bf-search__body');
    if (!input || !body) return;

    var emptyState = root.querySelector('[data-bf-search-state="empty"]');
    var recentHead = root.querySelector('[data-bf-recent-head]');
    var recentList = root.querySelector('[data-bf-recent-list]');
    var recentClear = root.querySelector('[data-bf-recent-clear]');
    var productsHead = root.querySelector('[data-bf-products-head]');
    var productsList = root.querySelector('[data-bf-products]');
    var colsHead = root.querySelector('[data-bf-collections-head]');
    var colsList = root.querySelector('[data-bf-collections]');
    var seeAll = root.querySelector('[data-bf-see-all]');
    var noneTitle = root.querySelector('[data-bf-none-title]');

    var RECENT_KEY = 'bf:recent';
    var RECENT_MAX = 5;
    var DEBOUNCE_MS = 150;
    var SUGGEST_LIMIT = 5;

    var SEARCH_URL = root.getAttribute('data-bf-search-url') || '/search';
    var NONE_LABEL = (noneTitle && noneTitle.getAttribute('data-bf-none-label')) || 'No results for';

    /* handle -> products_count; /search/suggest.json returns no counts, so the
       section renders the map from Liquid `collections` */
    var counts = {};
    try { counts = JSON.parse(root.getAttribute('data-bf-collection-counts') || '{}') || {}; } catch (e) { counts = {}; }

    /* currency prefix/suffix derived from a money_without_trailing_zeros sample,
       so no currency symbol is hardcoded here (CONTRACTS §6) */
    var sample = root.getAttribute('data-bf-money') || '';
    var firstDigit = sample.search(/\d/);
    var lastDigit = -1;
    for (var si = sample.length - 1; si >= 0; si--) { if (sample.charAt(si) >= '0' && sample.charAt(si) <= '9') { lastDigit = si; break; } }
    var moneyPre = firstDigit > 0 ? sample.slice(0, firstDigit) : '';
    var moneySuf = lastDigit >= 0 ? sample.slice(lastDigit + 1) : '';

    var states = {};
    BF.qsa('[data-bf-search-state]', root).forEach(function (el) { states[el.getAttribute('data-bf-search-state')] = el; });

    var timer = null;
    var ctrl = null;
    var shown = 'empty';

    /* ---------------- helpers ---------------- */
    function searchHref(q) { return SEARCH_URL + '?q=' + encodeURIComponent(q); }

    function showState(name) {
      shown = name;
      for (var k in states) { if (states.hasOwnProperty(k)) states[k].hidden = (k !== name); }
    }

    function money(raw) {
      if (raw === null || raw === undefined || raw === '') return '';
      var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
      if (!isFinite(n)) return '';
      var s = (Math.round(n * 100) % 100 === 0) ? String(Math.round(n)) : n.toFixed(2);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyPre + parts.join('.') + moneySuf;
    }

    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w;
    }

    function el(tag, cls) { var n = doc.createElement(tag); if (cls) n.className = cls; return n; }

    /* PLATFORM FACT (probed 2026-09-07): /search/suggest.json on this store never
       returns an empty product list — it falls back to fuzzy "did you mean" hits
       for any query (`zzzz` -> 3, `zzzqqq` -> 5, `qwertyuiop` -> 2, `xxxyyyzzz` -> 2),
       so an empty response can never drive D4 §9.4's "No results" state. We asked the
       API for fields title,product_type,vendor,variants.title, so a genuine hit must
       carry every query term in one of those (plus the handle, which is the title
       slug) — exactly the prototype's own matcher (D4 §9.5 `haystack.includes(t)`).
       Rows that fail it are the API's fallback and are dropped; when nothing is left,
       the sheet shows `No results for "q"`. */
    function terms(q) { return q.toLowerCase().trim().split(/\s+/).filter(Boolean); }

    function hay(parts) { return parts.filter(Boolean).join(' ').toLowerCase().replace(/[-_]/g, ' '); }

    function matches(ts, haystack) {
      for (var i = 0; i < ts.length; i++) { if (haystack.indexOf(ts[i]) === -1) return false; }
      return true;
    }

    function realProducts(q, list) {
      var ts = terms(q);
      return list.filter(function (p) {
        var vt = (p.variants || []).map(function (v) { return v && v.title; });
        return matches(ts, hay([p.title, p.type, p.vendor, p.handle].concat(vt)));
      });
    }

    function realCollections(q, list) {
      var ts = terms(q);
      return list.filter(function (c) { return matches(ts, hay([c.title, c.handle])); });
    }

    /* ---------------- recent searches (build addition; the prototype has a
       hard-coded list and no storage — BUILD-MAP A3) ---------------- */
    function readRecent() {
      try {
        var v = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
        if (!v || Object.prototype.toString.call(v) !== '[object Array]') return [];
        return v.filter(function (t) { return typeof t === 'string' && t.trim(); }).slice(0, RECENT_MAX);
      } catch (e) { return []; }
    }

    function writeRecent(list) {
      try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) { /* private mode / quota */ }
    }

    function pushRecent(q) {
      q = (q || '').trim();
      if (!q) return;
      var list = readRecent().filter(function (t) { return t.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      writeRecent(list);
    }

    function renderRecent() {
      if (!recentList) return;
      var list = readRecent();
      recentList.textContent = '';
      list.forEach(function (t) {
        var a = el('a', 'bf-search__rrow');
        a.href = searchHref(t);
        a.textContent = t;
        recentList.appendChild(a);
      });
      var has = list.length > 0;
      if (recentHead) recentHead.hidden = !has;
      recentList.hidden = !has;
      if (emptyState) emptyState.classList.toggle('is-no-recent', !has);
    }

    /* ---------------- rows ---------------- */
    function productRow(p, index) {
      var a = el('a', 'bf-search__row');
      a.href = p.url || '#';

      var thumb = el('span', 'bf-search__thumb');
      var src = (p.featured_image && p.featured_image.url) || p.image || '';
      if (src) {
        var img = doc.createElement('img');
        img.src = sized(src, 112);
        img.srcset = sized(src, 112) + ' 112w, ' + sized(src, 168) + ' 168w';
        img.sizes = '56px';
        img.width = 56;
        img.height = 56;
        img.alt = '';
        /* all five rows are inside the 664 px fold and are created in response to a
           keystroke, so lazy would only delay them (the prototype's `loading=lazy` is
           for a static list); the first two also get fetchpriority, as CONTRACTS §6 */
        img.loading = 'eager';
        img.decoding = 'async';
        if (index < 2 && 'fetchPriority' in img) img.fetchPriority = 'high';
        thumb.appendChild(img);
      }
      a.appendChild(thumb);

      var title = el('span', 'bf-search__row-title');
      title.textContent = p.title || '';
      a.appendChild(title);

      var price = el('span', 'bf-search__row-price');
      price.textContent = money(p.price);
      a.appendChild(price);
      return a;
    }

    function collectionRow(c) {
      var a = el('a', 'bf-search__crow');
      a.href = c.url || '#';

      var title = el('span', 'bf-search__crow-title');
      title.textContent = c.title || '';
      a.appendChild(title);

      var n = counts[c.handle];
      if (typeof n === 'number') {
        var span = el('span', 'bf-search__crow-count');
        span.textContent = String(n);
        a.appendChild(span);
        a.setAttribute('aria-label', (c.title || '') + ', ' + n + (n === 1 ? ' product' : ' products'));
      }
      return a;
    }

    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = realProducts(q, res.products || []);
      var collections = realCollections(q, res.collections || []);

      if (!products.length && !collections.length) {
        if (noneTitle) noneTitle.textContent = NONE_LABEL + ' "' + q + '"';
        showState('none');
        return;
      }

      productsList.textContent = '';
      products.slice(0, SUGGEST_LIMIT).forEach(function (p, i) { productsList.appendChild(productRow(p, i)); });
      productsList.hidden = !products.length;
      if (productsHead) productsHead.hidden = !products.length;

      colsList.textContent = '';
      collections.forEach(function (c) { colsList.appendChild(collectionRow(c)); });
      colsList.hidden = !collections.length;
      if (colsHead) colsHead.hidden = !collections.length;

      if (seeAll) seeAll.href = searchHref(q);
      showState('results');
    }

    /* ---------------- suggest (debounced, one in flight) ---------------- */
    function suggest(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=' + SUGGEST_LIMIT +
        '&resources[options][fields]=title,product_type,vendor,variants.title';
      var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
      if (window.AbortController) { ctrl = new window.AbortController(); opts.signal = ctrl.signal; }
      fetch(url, opts).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (data) {
        ctrl = null;
        if (!data) return;
        if (input.value.trim() !== q) return;   /* a newer query won */
        render(q, data);
      })['catch'](function () { ctrl = null; /* aborted or offline: keep the current state, console stays clean */ });
    }

    function onInput() {
      if (!BF.isMobile()) return;
      if (timer) { clearTimeout(timer); timer = null; }
      if (ctrl) { try { ctrl.abort(); } catch (e) { /* noop */ } ctrl = null; }
      var q = input.value.trim();
      if (!q) { renderRecent(); showState('empty'); return; }
      timer = setTimeout(function () { timer = null; suggest(q); }, DEBOUNCE_MS);
    }

    function submit(q) {
      q = (q || '').trim();
      if (!q) return;
      pushRecent(q);
      window.location.assign(searchHref(q));
    }

    /* ---------------- wiring ---------------- */
    input.addEventListener('input', onInput);
    input.addEventListener('search', onInput);   /* WebKit's native clear button */
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.keyCode !== 13) return;
      e.preventDefault();
      submit(input.value);
    });

    /* the native GET form is the no-JS fallback; if it ever submits (a soft-keyboard
       "search" key that does not raise keydown), still record the term first */
    if (input.form) {
      input.form.addEventListener('submit', function () { pushRecent(input.value); });
    }

    if (seeAll) {
      seeAll.addEventListener('click', function () { pushRecent(input.value); });
    }

    if (recentClear) {
      recentClear.addEventListener('click', function () {
        writeRecent([]);
        renderRecent();
      });
    }

    /* the prototype's openSearch always clears the query (.dc.html:955) */
    BF.on('bf:sheet:open', function (e) {
      if (!e.detail || e.detail.id !== 'search') return;
      if (timer) { clearTimeout(timer); timer = null; }
      if (ctrl) { try { ctrl.abort(); } catch (err) { /* noop */ } ctrl = null; }
      input.value = '';
      body.scrollTop = 0;
      renderRecent();
      showState('empty');
    });

    renderRecent();
    showState(shown);
  });
})();
